var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--circle-8", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ball-container" }, [
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_1" }, [_vm._v(" ")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_2" }, [_vm._v(" ")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_3" }, [_vm._v(" ")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_4" }, [_vm._v(" ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }